// HOSTING ENVIRONMENT
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || "unknown";
export const APP_HOST_URL =
  process.env.REACT_APP_APP_HOST_URL || "http://localhost:3001";

// bucket url
export const BUCKET_URL = process.env.REACT_APP_BUCKET_URL || "vp-sb-dev";
export const APP_IMAGE_URL =
  process.env.REACT_APP_APP_IMAGE_URL ||
  `https://${BUCKET_URL}.s3.ap-south-1.amazonaws.com/`;

// API
export const API_HOST =
  process.env.REACT_APP_API_HOST || "http://192.168.29.12:2511";
export const API_BASE_PATH = process.env.REACT_APP_API_BASE_PATH || "api";
export const API_BASE_URL = API_HOST + "/" + API_BASE_PATH;
export const API_PUBLIC_AUTHORIZATION_TOKEN =
  process.env.REACT_APP_API_PUBLIC_AUTHORIZATION_TOKEN ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6IlZQLVBVQkxJQy1VU0VSIiwiaWQiOjAsInJvbGVfaWQiOjAsImlhdCI6MTcxNDk2OTkyM30.rYHrqkWuirJGgfcBfx4oUVelYypt0rX6_P628eSHvEs";

// CRYPTO
export const CRYPTO_CIPHER_KEY =
  process.env.REACT_APP_CRYPTO_CIPHER_KEY || "J1xcC5G4uPmgo1bH0OUL97h6K76zkkMJ";
export const CRYPTO_CIPHER_IV =
  process.env.REACT_APP_CRYPTO_CIPHER_IV || "ma93qsl0h3a01rpsl9e78e4z2fg0lxtn";

// RAZOR PAY
export const RP_KEY_ID =
  process.env.REACT_APP_RP_KEY_ID || "rzp_test_JE0vZHRIYsJ39E";
export const RP_COMPANY_NAME =
  process.env.REACT_APP_RP_COMPANY_NAME || "V PROSPER";

// ZOOM
export const ZOOM_API_KEY =
  process.env.REACT_APP_ZOOM_API_KEY || "FZNKVudpTouLW3jhmEU9xg";

// FIREBASE
export const FIREBASE_CONFIG = {
  apiKey:
    process.env.REACT_APP_FIREBASE_CONFIG_API_KEY ||
    "AIzaSyDEdCpHDAiYRAFDdOPSmjGh3Z7viqaynL0",
  authDomain:
    process.env.REACT_APP_FIREBASE_CONFIG_AUTH_DOMAIN ||
    "vp-dev-7a1f2.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_CONFIG_PROJECT_ID || "vp-dev-7a1f2",
  storageBucket:
    process.env.REACT_APP_FIREBASE_CONFIG_STORAGE_BUCKET ||
    "vp-dev-7a1f2.appspot.com",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_CONFIG_MESSAGEING_SENDER_ID ||
    "679877003249",
  appId:
    process.env.REACT_APP_FIREBASE_CONFIG_APP_ID ||
    "1:679877003249:web:5f523744f5adf8bf83a650",
};
export const FIREBASE_VAP_ID_KEY =
  process.env.REACT_APP_FIREBASE_VAP_ID_KEY ||
  "BCe8dBGeJhyE4kD76NZaLl7OOcC5l8P19Ww4dxwspT5q6bas-PLEN6_-9VnNaf0iG2NYeem6wIZnNLWLsQ3ay70";

// CAPTCHA
export const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
  "6Ld9wOwpAAAAACPD9zQjsjMbkjHbm7dVtBYAU72B";
export const RECAPTCHA_SECRET_KEY =
  process.env.REACT_APP_RECAPTCHA_SECRET_KEY ||
  "6Ld9wOwpAAAAAAByR5Fd8gEZKF0jxI3gOlS7gzsn";

// GEOCODING
export const GEOCODING_API_KEY =
  process.env.REACT_APP_GEOCODING_API_KEY ||
  "AIzaSyCZ_EOYYDEKYcELdTEIFxtvWuERbBtoEIg";

// Google map

export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
  "AIzaSyB6Il6zGXxbQVmXJq8eoTfjeeQvxNbKicM";

// APP ENVIRONMENT
export const APP_DEFAULT_LANGUAGE =
  process.env.REACT_APP_APP_DEFAULT_LANGUAGE || "en";
export const PER_PAGE_ROW_LIST = process.env.REACT_APP_PER_PAGE_ROW_LIST
  ? process.env.REACT_APP_PER_PAGE_ROW_LIST.split(",").map(Number)
  : [5, 10, 25, 50];
export const PER_PAGE_ROWS = process.env.REACT_APP_PER_PAGE_ROW
  ? Number(process.env.REACT_APP_PER_PAGE_ROW)
  : 10;
export const CALLING_CODE = process.env.REACT_APP_CALLING_CODE || "+91";
